import { createQueryKeySet } from '@akin-home/utils/react-query';
export const recipesQueryKey = createQueryKeySet({ key: 'recipes' });
